import { KeenSliderInstance } from 'keen-slider/react';

export function KeyboardPlugin(slider: KeenSliderInstance) {
  function keyboardListener(e: KeyboardEvent) {
    if (e.key === 'ArrowLeft') {
      slider.prev();
    }

    if (e.key === 'ArrowRight') {
      slider.next();
    }
  }

  function addKeyboardListener() {
    document.addEventListener('keydown', keyboardListener);
  }

  function removeKeyboardListener() {
    document.removeEventListener('keydown', keyboardListener);
  }

  slider.on('created', addKeyboardListener);
  slider.on('destroyed', removeKeyboardListener);
}
